import ArrowLeftIcon from "@assets/icons/arrowLeft"
import ArrowSquareLeftIcon from "@assets/icons/arrowSquareLeft"
import { EyeIcon } from "@assets/icons/Eye.tsx"
import { ChartIcon } from "@assets/icons/Chart"
import { PatientIcon } from "@assets/icons/patient"
import { NotesTwoIcon } from "@assets/icons/NotesTwo"
import Notes from "./Notes"
import Patient from "./Patient"
import Prescribe from "./Prescribe"
import { useEffect, useState } from "react"
import NavigationSection from "./NavigationItem"
import { useSearchParams } from "react-router-dom"
import usePatient from "@hooks/usePatient"
import { Loader } from "@components/Loader"
import { useSelector } from "react-redux"
import { Link } from "react-router-dom"
import Performance from "./Performance"
import VRToggle from "./VRToggle"
import PatientHeader from "./PatientHeader"

const ViewPatient = () => {
  const [currentSection, setCurrentSection] = useState("0")
  const { handleGetSinglePatient } = usePatient()
  const { isGetSinglePatientLoading } = useSelector((state) => {
    return state.patient
  })
  const [searchParams] = useSearchParams()
  const patientId = searchParams.get("_id")
  const [mode, setMode] = useState("off")

  const handleModeChange = (newMode) => {
    setMode(newMode)
  }

  useEffect(() => {
    handleGetSinglePatient({ _id: patientId })
  }, [handleGetSinglePatient, patientId])

  return (
    <div className="flex flex-col">
      <Link to="/manage-patient-vision" className="hidden md:flex gap-2 mb-8">
        <ArrowLeftIcon />
        <span className="text-sm text-[--primary-blue] font-bold">BACK</span>
      </Link>
      <Link to="/manage-patient-vision" className="md:hidden mb-5 mx-4 md:mx-0">
        <ArrowSquareLeftIcon />
      </Link>
      <div className="flex items-center justify-between w-full px-4 md:px-0">
        <div className="flex flex-col w-full">
          <div className="text-sm md:text-3xl font-bold text-[--primary-blue] md:text-[--quaternary-black] md:font-normal pl-3 md:pl-6 pb-7">
            View Patient
          </div>
          <div className="flex justify-center md:justify-start gap-1 bg-[--primary-blue-light] md:bg-[transparent] rounded-t-3xl px-3 pt-3 md:p-0 mb-4 md:m-0 md:ml-6">
            <NavigationSection
              name="Patient"
              Icon={PatientIcon}
              sectionId="0"
              currentSection={currentSection}
              setCurrentSection={setCurrentSection}
            />
            <NavigationSection
              name="Prescribe"
              Icon={EyeIcon}
              sectionId="1"
              currentSection={currentSection}
              setCurrentSection={setCurrentSection}
            />
            <NavigationSection
              name="Performance"
              Icon={ChartIcon}
              sectionId="2"
              currentSection={currentSection}
              setCurrentSection={setCurrentSection}
            />
            <NavigationSection
              name="Notes"
              Icon={NotesTwoIcon}
              sectionId="3"
              currentSection={currentSection}
              setCurrentSection={setCurrentSection}
            />
          </div>
        </div>
        <div className="hidden md:block pr-3 md:pr-6">
          {(currentSection === "1" || currentSection === "2") && (
            <VRToggle mode={mode} onModeChange={handleModeChange} />
          )}
        </div>
      </div>
      {(currentSection === "1" || currentSection === "2") && (
        <div className="block md:hidden px-4 pb-4 pt-3">
          <PatientHeader />
          <div className="pt-5">
            {" "}
            {/* Added padding */}
            <VRToggle mode={mode} onModeChange={handleModeChange} />
          </div>
        </div>
      )}
      {currentSection === "0" ? <Patient /> : null}
      {currentSection === "1" ? <Prescribe mode={mode} /> : null}
      {currentSection === "2" ? <Performance mode={mode} /> : null}
      {currentSection === "3" ? <Notes /> : null}

      {isGetSinglePatientLoading ? (
        <div className="fixed right-0 left-0 top-0 bottom-0 bg-[#25323E3D] flex items-center justify-center z-[1000000]">
          <Loader />
        </div>
      ) : null}
    </div>
  )
}

export default ViewPatient
